<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Organisasi (PAU/Fakultas/Sekolah)"
        class="card-wrapper"
        >

        <form>
          <div style="height: 80px" class="form-input row">
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Parent</p>
              <v-autocomplete
                no-data-text="Tidak ada data"
                v-model="parentFilter"
                :items="organisasis"
                item-text="nama"
                item-value="id"
                placeholder="Cari berdasarkan Parent"
                clearable
                dense
                outlined
                @keydown.enter.prevent
              ></v-autocomplete>
            </div>
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Level</p>
              <v-select
                v-model="levelFilter"
                :items="levelItems"
                placeholder="Cari berdasarkan Level"
                clearable
                dense
                outlined
              ></v-select>
            </div>
          </div>
          <br>
        </form>
        <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari Kode atau Nama Organisasi"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            @click="addItem()"
          >
            Tambah
          </v-btn>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="filteredOrganisasis"
            :search="search"
            :options.sync="tableOptions"
            :loading="isLoading"
            loading-text="Memuat data..."
            no-data-text="Data Organisasi (PAU/Fakultas/Sekolah) tidak ditemukan"
            no-results-text="Data Organisasi (PAU/Fakultas/Sekolah) tidak ditemukan"
            hide-default-footer
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            />
          </template>
          <template v-slot:item.status="{ item }">
            <esign-status-tag :tone="item.status == true ? 'success' : 'neutral'">{{ item.status == true ? "Aktif" : "Tidak Aktif" }}</esign-status-tag>
          </template>
          <template v-slot:item.file_stamp="{ item }">
            <v-icon small>
              {{ item.file_stamp ? 'mdi-check' : 'mdi-close' }}
            </v-icon>
          </template>
          <template v-slot:item.parent="{ item }">
            {{ formatParent(item.organisasi_parent) }}
          </template>
          <template v-slot:item.aksi="{ item }">
            <v-btn class="mx-1 mt-1 mb-1" x-small color="primary" dark @click="detailItem(item)">
              <v-icon small class="mr-1">mdi-eye</v-icon>
              Detail
            </v-btn>
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="orange" dark @click="editItem(item)">
              <v-icon small class="mr-1">mdi-pencil</v-icon>
              Ubah
            </v-btn>
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="red" dark @click="deleteItem(item)">
              <v-icon small class="mr-1">mdi-delete</v-icon>
              Hapus
            </v-btn>
          </template>
        </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card class="card-modal">
            <v-card-title>
              <span class="headline">Hapus Organisasi (PAU/Fakultas/Sekolah)</span>
            </v-card-title>
  
            <v-card-text>
              Apakah anda yakin ingin menghapus Organisasi (PAU/Fakultas/Sekolah) {{namaDelete}}?
            </v-card-text>
  
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn @click="close">Batal</v-btn>
              <v-btn color="primary" dark @click="confirmDelete">Hapus</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";

export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["search", "parentFilter", "levelFilter", "tableOptions"],
  restoreAfterLoad: ["tableOptions"],
  data () {
    return {
      organisasis: [],
      search: '',
      tableOptions: {},
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      currentPeran: "",
      isLoading: true,
      dialog: false,
      namaDelete: null,
      totalData: 0,
      parentFilter: null,
      levelFilter: null,
      levelItems: [0, 1, 2],
      headers: [
        {
          text: 'Kode',
          align: 'start',
          sortable: true,
          value: 'kode_org',
        },
        { text: 'Nama Organisasi (PAU/Fakultas/Sekolah)', 
          sortable: true,
          value: 'nama' 
        },
        { text: 'Status', 
          sortable: true,
          value: 'status' 
        },
        { text: 'Memiliki Filestamp', 
          sortable: true,
          value: 'file_stamp' 
        },
        { text: 'Parent', 
          sortable: false,
          value: 'parent' 
        },
        { text: 'Level', 
          sortable: true,
          value: 'level' 
        },
        { text: 'Aksi',
          sortable: false,
          value: 'aksi',
          width: '275px',
        },
      ],
    }
  },
  created() {
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    console.log("loading")
    this.getData();
  },
  computed: {
    filteredOrganisasis() {
      let filtered = this.organisasis;
      if (this.parentFilter) {
        filtered = filtered.filter(org => org.organisasi_parent && org.organisasi_parent.id === this.parentFilter);
      }
      if (this.levelFilter !== null) {
        filtered = filtered.filter(org => org.level === this.levelFilter);
      }
      return filtered;
    },
    totalFilteredData() {
      return this.filteredOrganisasis.length;
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      console.log(this.isLoading);
      this.currentPeran = localStorage.getItem("currentPeran")
      if (this.currentPeran === "A05") {
        console.log("Pengguna peran A05, idOrganisasi: " + JSON.parse(localStorage.getItem("user")).pengguna.Organisasi.KodeOrg)
        console.log(JSON.parse(localStorage.getItem("user")).pengguna.Organisasi)
        this.$router.push('/detail-organisasi/' + JSON.parse(localStorage.getItem("user")).pengguna.Organisasi.KodeOrg);
      }
      apiServer
        .get("/organisasi/all")
        .then(response => {
          this.organisasis = response.data.data;
          this.isLoading = false;
          console.log("loaded")
          console.log(this.organisasis)
          this.totalData = response.data.total
          if(localStorage.getItem("createSuccess") != null) {
            this.showSnackbar("orange", localStorage.getItem("createSuccess"));
            this.close()
            localStorage.removeItem("createSuccess")
          }
          if(localStorage.getItem("updateSuccess") != null) {
            this.showSnackbar("orange", localStorage.getItem("updateSuccess"));
            this.close()
            localStorage.removeItem("updateSuccess")
          }
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    formatParent(parent) {
      if (parent) {
        return `${parent.nama} - ${parent.kode_org}`;
      }
      return '-';
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    detailItem(item){
      this.$router.push('/detail-organisasi/' + item.kode_org);
    },
    addItem(){
      this.$router.push('/tambah-organisasi');
    },
    editItem(item){
      console.log(item)
      this.$router.push('/ubah-organisasi/' + item.kode_org);
    },
    deleteItem(val) {
      console.log("delete " +val.nama)
      this.dialog = true
      this.namaDelete = val.nama
      this.idDelete = val.id
    },
    confirmDelete() {
      apiServer
          .delete("/organisasi/delete/id/" + this.idDelete)
          .then(response => {
            this.showSnackbar("orange", "Hapus Organisasi berhasil dilakukan");
            this.close()
            this.getData()
          })
          .catch(error => {
            console.log("There was an error:", error.response);
            this.showSnackbar(
                "error",
                error.response.data.message
            );
          });
    },
    close() {
      this.namaDelete = ""
      this.idDelete = 0
      this.dialog = false;
    },
  }
}
</script>